import { render, staticRenderFns } from "./pubOfficialAccounts.vue?vue&type=template&id=927d4e3a&scoped=true"
import script from "./pubOfficialAccounts.vue?vue&type=script&lang=js"
export * from "./pubOfficialAccounts.vue?vue&type=script&lang=js"
import style0 from "./pubOfficialAccounts.vue?vue&type=style&index=0&id=927d4e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927d4e3a",
  null
  
)

export default component.exports